import { useTranslation } from 'react-i18next'
import './AlertBox.sass'
interface Props {
    message: string
    onConfirm: () => void
    onCancel: () => void
}

const AlertBox: React.FC<Props> = (props) => {
    const { t } = useTranslation()
    return (
        <div className="alert-box">
            <div className="alert-box__body">
                <div className="alert-box__title">{props.message}</div>
            </div>
            <div className="alert-box__buttons">
                <button className="alert-box__buttons__basic-button" onClick={props.onCancel}>
                    {t('general.cancel')}
                </button>
                <button className="alert-box__buttons__basic-button basic-button--accent" onClick={props.onConfirm}>
                    {t('general.confirm')}
                </button>
            </div>
        </div>
    )
}

export default AlertBox
